import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CertificationsSection from "./components/CertificationsSection";
import WhatsAppButton from "./components/WhatsAppButton";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import CoursesPage from "./pages/CoursesPage";
import WhyChooseUsPage from "./pages/WhyChooseUsPage";
import DynamicPage from "./pages/DynamicPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import PageBuilder from "./pages/PageBuilder";
import SAPSuccessFactorsLanding from "./pages/SAPSuccessFactorsLanding";
import SAPSuccessFactorsThankYou from "./pages/SAPSuccessFactorsThankYou";
import ModuleLandingPage from "./pages/ModuleLandingPage";
import ModuleThankYouPage from "./pages/ModuleThankYouPage";
import ContactFormModal from "./components/ContactFormModal";
import { Toaster } from "./components/ui/sonner";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Meta Pixel PageView Tracker for Route Changes
function MetaPixelTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location]);

  return null;
}

function App() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <MetaPixelTracker />
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/page-builder" element={<PageBuilder />} />
          <Route path="/admin/page-builder/:pageId" element={<PageBuilder />} />
          
          {/* SAP SuccessFactors Main Landing Page */}
          <Route path="/sap-successfactors" element={<SAPSuccessFactorsLanding />} />
          <Route path="/sap-successfactors/thank-you" element={<SAPSuccessFactorsThankYou />} />
          
          {/* SAP SuccessFactors Module Landing Pages */}
          <Route path="/sap-successfactors-employee-central" element={<ModuleLandingPage />} />
          <Route path="/sap-successfactors-employee-central/thank-you" element={<ModuleThankYouPage />} />
          <Route path="/sap-successfactors-rcm" element={<ModuleLandingPage />} />
          <Route path="/sap-successfactors-rcm/thank-you" element={<ModuleThankYouPage />} />
          <Route path="/sap-successfactors-lms" element={<ModuleLandingPage />} />
          <Route path="/sap-successfactors-lms/thank-you" element={<ModuleThankYouPage />} />
          <Route path="/sap-successfactors-compensation" element={<ModuleLandingPage />} />
          <Route path="/sap-successfactors-compensation/thank-you" element={<ModuleThankYouPage />} />
          <Route path="/sap-successfactors-time-management" element={<ModuleLandingPage />} />
          <Route path="/sap-successfactors-time-management/thank-you" element={<ModuleThankYouPage />} />
          <Route path="/sap-successfactors-onboarding" element={<ModuleLandingPage />} />
          <Route path="/sap-successfactors-onboarding/thank-you" element={<ModuleThankYouPage />} />
          <Route path="/sap-successfactors-story-reports" element={<ModuleLandingPage />} />
          <Route path="/sap-successfactors-story-reports/thank-you" element={<ModuleThankYouPage />} />
          <Route path="/sap-successfactors-ecp" element={<ModuleLandingPage />} />
          <Route path="/sap-successfactors-ecp/thank-you" element={<ModuleThankYouPage />} />
          
          {/* Public Routes */}
          <Route path="/*" element={
            <>
              <Navbar onContactClick={() => setIsContactModalOpen(true)} />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/courses" element={<CoursesPage onContactClick={() => setIsContactModalOpen(true)} />} />
                <Route path="/why-choose-us" element={<WhyChooseUsPage />} />
                {/* Dynamic Pages - catches custom pages like /gallery, /faq, /careers */}
                <Route path="/page/:slug" element={<DynamicPage />} />
              </Routes>
              <CertificationsSection />
              <Footer onContactClick={() => setIsContactModalOpen(true)} />
              <ContactFormModal 
                isOpen={isContactModalOpen} 
                onClose={() => setIsContactModalOpen(false)}
              />
            </>
          } />
        </Routes>
        <WhatsAppButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
